var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWaitingDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "waiting_dark",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_47973",
    "data-name": "Path 47973",
    d: "M0,0H24V24H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_47974",
    "data-name": "Path 47974",
    d: "M13.49,5.48a2,2,0,1,0-2-2A2.006,2.006,0,0,0,13.49,5.48Zm-3.17,12,.57-2.5,2.1,2v5a1,1,0,0,0,2,0V16.34a1.989,1.989,0,0,0-.62-1.45l-1.48-1.41.6-3a7.321,7.321,0,0,0,4.36,2.41,1,1,0,0,0,.29-1.98,4.864,4.864,0,0,1-3.45-2.33l-1-1.6a2.062,2.062,0,0,0-1.7-1c-.3,0-.5.1-.8.1L7.21,7.76A2.011,2.011,0,0,0,5.99,9.61v2.37a1,1,0,0,0,2,0V9.58l1.8-.7-1.6,8.1-3.92-.8a1,1,0,0,0-1.18.78V17a1,1,0,0,0,.78,1.18L7.98,19A2,2,0,0,0,10.32,17.48Z",
    fill: "#4b4e6d"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaitingDark);
export default __webpack_public_path__ + "static/media/waiting_dark.98c4585f0f0afb0d10050de699c3d257.svg";
export { ForwardRef as ReactComponent };